import React, { useState } from 'react'
import AccordianItem from '../components/AccordianItem';
import { technicalSkills } from '../../../data/TechnicalSkillsData';

const TechnicalSkillsAccordian = () => {

	const [selected, setSelected] = useState(technicalSkills[0].id);
	const toggleAccordian = (id: number) => {
		id === selected ? setSelected(0) : setSelected(id);
	}

	return (
		<div className='accordian accordian-container'>
			{technicalSkills.map((technicalSkill) => {
				return <AccordianItem
					key={technicalSkill.id}
					skill={technicalSkill}
					toggleAccordian={toggleAccordian}
					selected={selected}
				/>
			})}
		</div>
	)
}

export default TechnicalSkillsAccordian;